var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 18,
    viewBox: "0 0 40 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8440_135577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30249 1.75929L8.30249 1.2339C8.30249 0.999009 8.11063 0.808594 7.87396 0.808594L4.8028 0.808594C4.56613 0.808594 4.37427 0.999009 4.37427 1.2339L4.37427 1.75929C4.37427 1.99418 4.56613 2.18459 4.8028 2.18459L7.87396 2.18459C8.11063 2.18459 8.30249 1.99418 8.30249 1.75929Z",
    fill: "#60585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80151 16.3726L8.80151 15.8472C8.80151 15.6123 8.60966 15.4219 8.37299 15.4219L5.30182 15.4219C5.06515 15.4219 4.87329 15.6123 4.87329 15.8472L4.87329 16.3726C4.87329 16.6075 5.06515 16.7979 5.30182 16.7979L8.37299 16.7979C8.60966 16.7979 8.80151 16.6075 8.80151 16.3726Z",
    fill: "#60585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0613 10.2082C36.0453 10.4793 36.042 10.7599 36.0783 11.0289C36.1138 11.206 36.2663 11.5973 36.5114 11.4082C36.7631 11.1483 36.7245 10.6883 36.6963 10.3598L36.9955 10.3344C37.0329 10.7866 37.045 11.3334 36.6795 11.6641C36.2043 11.9604 35.861 11.4969 35.7802 11.0684C35.7436 10.782 35.7628 10.4955 35.7458 10.2083L36.0613 10.2083L36.0613 10.2082Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6396 10.2082C37.6556 10.4793 37.659 10.7599 37.6226 11.0289C37.5871 11.206 37.4346 11.5973 37.1895 11.4082C36.9378 11.1483 36.9764 10.6883 37.0047 10.3598L36.7055 10.3344C36.668 10.7866 36.656 11.3334 37.0214 11.6641C37.4966 11.9604 37.84 11.4969 37.9207 11.0684C37.9573 10.7819 37.9382 10.4955 37.9551 10.2083L37.6396 10.2083L37.6396 10.2082Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9544 9.14919C36.9445 9.25146 36.9488 9.35661 36.9483 9.45915C36.948 9.54593 36.9032 9.83722 36.998 9.89127C37.0656 9.91033 37.143 9.87789 37.1807 9.82152C37.2515 9.68489 37.2155 9.50044 37.2084 9.35384C37.1997 9.17448 37.1798 8.93124 37.3997 8.87644C37.5792 8.85944 37.7514 8.97048 37.8556 9.10898C37.9691 9.29222 37.9482 9.50081 37.9222 9.70522C37.9059 9.82694 37.8872 9.94831 37.8733 10.0703L37.6836 10.0479C37.6983 9.92548 37.7187 9.80384 37.735 9.68164C37.7534 9.53217 37.7814 9.36065 37.7012 9.22379C37.6452 9.14503 37.5418 9.06907 37.4405 9.06848C37.3651 9.06776 37.3949 9.30154 37.397 9.34413C37.4077 9.5419 37.4398 9.75691 37.3368 9.93639C37.2276 10.081 37.0189 10.1448 36.8633 10.0327C36.7232 9.88623 36.7594 9.64525 36.7587 9.45915C36.7583 9.35661 36.7625 9.25146 36.7527 9.14919L36.9544 9.14919Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7581 8.99219C36.7701 8.87354 36.7654 8.75067 36.766 8.63162C36.7668 8.40703 36.7651 8.18244 36.7642 7.95779C36.7639 7.9128 36.7636 7.86774 36.7623 7.82274L36.9334 7.82274C36.932 7.86774 36.9317 7.9128 36.9315 7.95779C36.9306 8.18244 36.9289 8.40703 36.9297 8.63162C36.9303 8.75067 36.9255 8.87354 36.9376 8.99219L36.7581 8.99219Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8835 8.32938C36.9494 8.33857 37.0188 8.33395 37.085 8.33441C37.2169 8.33505 37.3488 8.3351 37.4808 8.33406C37.5682 8.33337 37.6556 8.33245 37.743 8.33221C37.7953 8.33216 37.8477 8.33233 37.8999 8.33245L37.8999 8.52428C37.8477 8.5244 37.7953 8.52457 37.743 8.52446C37.6556 8.52428 37.5682 8.52336 37.4808 8.52266C37.3488 8.52162 37.2169 8.52163 37.085 8.52226C37.0188 8.52278 36.9494 8.5181 36.8835 8.52734L36.8835 8.32938Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7937 7.59194C36.8789 7.60279 36.9685 7.59759 37.0541 7.59858C37.2693 7.60086 37.4844 7.60111 37.6996 7.59898C37.7701 7.59813 37.8405 7.59709 37.911 7.59571L37.911 7.75795C37.8405 7.75662 37.7701 7.75553 37.6996 7.75468C37.4844 7.75255 37.2693 7.75285 37.0541 7.75508C36.9685 7.75612 36.8789 7.75087 36.7937 7.76172L36.7937 7.59194Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7422 7.69531C36.75 7.62546 36.7459 7.55348 36.7478 7.48328C36.7547 7.33332 36.7988 7.20144 36.968 7.18177C37.1375 7.17726 37.2391 7.26956 37.2705 7.43289C37.2802 7.50953 37.2773 7.58444 37.2691 7.66103L37.111 7.64354C37.1178 7.58305 37.121 7.52355 37.1135 7.46297C37.0987 7.38345 37.0696 7.34318 36.9849 7.34382C36.9083 7.34996 36.9107 7.42294 36.9076 7.48724C36.9062 7.55576 36.9035 7.627 36.9112 7.69531L36.7422 7.69531Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1948 7.625C37.2016 7.56441 37.1984 7.50154 37.1989 7.44071C37.2 7.31002 37.1897 7.16343 37.2755 7.05488C37.3734 6.96308 37.4938 6.99469 37.6098 7.02907C37.6883 7.05245 37.7654 7.07237 37.8477 7.0749C37.8638 7.07505 37.8797 7.0749 37.8957 7.0745L37.8999 7.23823C37.8808 7.23873 37.8618 7.23888 37.8426 7.23868C37.7462 7.23561 37.6558 7.21262 37.564 7.18508C37.5218 7.17259 37.4439 7.13786 37.3997 7.161C37.3364 7.21629 37.3591 7.36773 37.3597 7.44071C37.3602 7.50154 37.3571 7.56441 37.3638 7.625L37.1948 7.625Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7427 7.64514L36.7427 7.76172L36.8937 7.76172L36.8937 7.64514L36.7427 7.64514Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3382 5.81183C37.6855 5.81183 37.9675 6.06925 37.9675 6.38641C37.9675 6.70357 37.6855 6.96094 37.3382 6.96094C36.9909 6.96094 36.709 6.70357 36.709 6.38641C36.709 6.06925 36.9909 5.81183 37.3382 5.81183ZM37.3222 5.99504C37.5587 5.99504 37.7507 6.17041 37.7507 6.38641C37.7507 6.60246 37.5587 6.77778 37.3222 6.77778C37.0855 6.77778 36.8935 6.60246 36.8935 6.38641C36.8935 6.17041 37.0855 5.99504 37.3222 5.99504Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5085 16.7437L34.5085 16.2183C34.5085 15.9834 34.3167 15.793 34.08 15.793L31.0089 15.793C30.7722 15.793 30.5803 15.9834 30.5803 16.2183L30.5803 16.7437C30.5803 16.9786 30.7722 17.169 31.0089 17.169L34.08 17.169C34.3167 17.169 34.5085 16.9786 34.5085 16.7437Z",
    fill: "#60585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3547 1.38038L34.3547 0.854992C34.3547 0.620103 34.1629 0.429687 33.9262 0.429687L30.855 0.429687C30.6184 0.429687 30.4265 0.620103 30.4265 0.854992L30.4265 1.38038C30.4265 1.61527 30.6184 1.80569 30.855 1.80569L33.9262 1.80569C34.1629 1.80569 34.3547 1.61527 34.3547 1.38038Z",
    fill: "#60585A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.31871 8.85616C0.200809 3.25456 1.21321 2.39602 1.37998 1.56819C3.31554 0.740605 19.6359 0.583462 20.9702 1.07996C23.9921 1.45117 24.4925 0.835428 28.1347 0.649599C32.3882 0.295877 30.0229 1.13584 34.3483 0.429687C38.8515 1.50265 38.9432 -0.51833 39.3713 8.77833C39.2515 17.3098 38.8515 16.1084 34.3483 17.181C30.0229 16.4748 32.3881 17.3148 28.1347 16.9611C24.4927 16.7752 23.9923 16.1595 20.9702 16.5307C19.636 17.0272 3.31574 16.8701 1.37998 16.0425C0.623599 14.7468 0.31871 11.3133 0.31871 8.85557L0.31871 8.85616Z",
    fill: "url(#paint0_linear_8440_135577)",
    stroke: "#E2E2E2",
    strokeOpacity: 0.45912,
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.332 2.05872L21.2168 3.12553C21.2168 3.12553 13.5007 3.12553 13.3724 2.97315C13.2438 2.82071 11.0577 1.60156 11.0577 1.60156C11.0577 1.60156 25.0747 1.90632 25.3323 2.05877L25.332 2.05872Z",
    fill: "url(#paint1_radial_8440_135577)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5815 15.7973L21.4663 14.7305C21.4663 14.7305 13.7502 14.7305 13.6219 14.8828C13.4933 15.0353 11.3072 16.2544 11.3072 16.2544C11.3072 16.2544 25.3242 15.9497 25.5818 15.7972L25.5815 15.7973Z",
    fill: "url(#paint2_radial_8440_135577)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0554 1.8417C37.0459 1.2637 27.4437 1.30586 26.6866 2.23064C27.4898 3.12387 28.2358 8.29842 28.1665 9.28231C28.2472 10.2874 27.7308 14.2212 26.939 15.4298C26.8238 15.7557 38.0553 16.4071 38.8124 15.4823C39.6963 12.5921 39.6963 2.99749 38.0558 1.8417L38.0554 1.8417Z",
    fill: "url(#paint3_linear_8440_135577)",
    stroke: "#DBDBDB",
    strokeOpacity: 0.45912,
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5545 2.06785C26.5545 2.06785 27.8971 5.31427 27.9314 8.93621C27.9634 12.1976 27.4511 13.6706 26.6826 15.6545C24.2489 15.414 21.9434 15.1735 21.1748 14.5723C22.584 9.04159 22.584 8.68093 21.1748 3.15017C21.943 3.02979 26.4265 1.94767 26.5543 2.0679L26.5545 2.06785Z",
    fill: "url(#paint4_radial_8440_135577)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4142 2.25476C26.4142 2.25476 27.6502 5.41463 27.6818 8.94031C27.7113 12.1148 27.2396 13.5485 26.5321 15.4797C24.2916 15.2457 22.1691 15.0116 21.4616 14.4264C22.7587 9.04281 22.7586 8.69206 21.4615 3.30844C22.169 3.19143 26.2962 2.13814 26.4141 2.25515L26.4142 2.25476Z",
    fill: "black",
    fillOpacity: 0.7044,
    stroke: "black",
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8752 3.75137C9.91175 3.1386 4.23167 2.64844 4.23167 2.64844C3.36731 3.62885 2.99689 8.6533 2.99689 8.77616C2.99689 9.14381 3.36733 14.1682 4.6021 15.0263C5.34296 15.0263 10.6525 14.536 12.9985 14.0458C12.3812 9.75663 12.6281 3.99694 12.8751 3.75172L12.8752 3.75137Z",
    fill: "url(#paint5_radial_8440_135577)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6177 4.01032C9.78768 3.42514 4.36352 2.95703 4.36352 2.95703C3.5381 3.89331 3.18434 8.6914 3.18434 8.80881C3.18434 9.15991 3.5381 13.9581 4.71728 14.7775C5.42479 14.7775 10.4951 14.3093 12.7358 13.8412C12.1463 9.74514 12.3821 4.24465 12.6179 4.01032L12.6177 4.01032Z",
    fill: "black",
    fillOpacity: 0.78616,
    stroke: "black",
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4712 15.9492L25.3533 17.3536C25.3533 17.3536 24.6458 18.0558 24.292 17.5877C23.9383 17.1195 24.4099 15.9492 24.4099 15.9492L25.4712 15.9492Z",
    fill: "url(#paint6_linear_8440_135577)",
    stroke: "black",
    strokeOpacity: 0.55346,
    strokeWidth: 0.990285
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2351 1.83063L25.1172 0.426241C25.1172 0.426241 24.4097 -0.275953 24.0559 0.19216C23.7022 0.660322 24.1738 1.83063 24.1738 1.83063L25.2351 1.83063Z",
    fill: "url(#paint7_linear_8440_135577)",
    stroke: "black",
    strokeOpacity: 0.54717,
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6456 2.13625L20.8721 2.95546C20.8721 2.95546 13.797 2.95546 13.6792 2.83845C13.5613 2.72138 11.5567 1.78516 11.5567 1.78516C11.5567 1.78516 24.4096 2.01919 24.6458 2.13625L24.6456 2.13625Z",
    fill: "black",
    fillOpacity: 0.68554,
    stroke: "black",
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8811 15.7137L21.1077 14.8945C21.1077 14.8945 14.0326 14.8945 13.9148 15.0115C13.7969 15.1286 11.7923 16.0648 11.7923 16.0648C11.7923 16.0648 24.6452 15.8308 24.8813 15.7137L24.8811 15.7137Z",
    fill: "black",
    fillOpacity: 0.74843,
    stroke: "black",
    strokeWidth: 0.792228
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8440_135577",
    x1: 1.0611,
    y1: 15.143,
    x2: 1.21087,
    y2: 2.41223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.200833,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494515,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773265,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8440_135577",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1953 2.36364) rotate(90) scale(0.762022 7.1374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34332F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8440_135577",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4448 15.4925) rotate(90) scale(0.762022 7.1374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34332F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8440_135577",
    x1: 40.3262,
    y1: 6.70937,
    x2: 26.0078,
    y2: 15.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0193957,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483083,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8440_135577",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.554 8.85735) rotate(90) scale(6.79826 3.37907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34332F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8440_135577",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.99792 8.83809) rotate(90) scale(6.18921 5.0009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34332F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8440_135577",
    x1: 24.5508,
    y1: 17.4784,
    x2: 24.8505,
    y2: 15.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8440_135577",
    x1: 24.8539,
    y1: 1.95885,
    x2: 24.5543,
    y2: 0.150368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8440_135577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7778,
    height: 39.402,
    fill: "white",
    transform: "translate(39.4023) rotate(90)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.5337555a8e6ec5ea625ba0417a86e6f1.svg";
export { ForwardRef as ReactComponent };